<template>
    <div class="container section-menu-page">
        <div class="section-title-wrap">
            <h2 class="section-title">{{ labels.title }}</h2> 
        </div>
        <div>
            <div class="admin-home-card table-corporate-body main-menu-scroll-shell">
                <b-container style="padding: 18px 40px 40px;">
                    <!-- Mostrar submenús dinámicos -->
                    <b-row
                        id="home-buttons"
                        v-for="subMenu in visibleSubmenus"
                        :key="subMenu.id || subMenu.ruta"
                    >
                        <b-col md="4" class="p-2 admin-menu-card-col" cols="3">
                            <button
                                type="button"
                                class="md-card admin-menu-card-button"
                                @click="goToRoute(subMenu)"
                            >
                                <div>
                                    <div>
                                        <div class="md-title-tarjeta">
                                            <span>{{ subMenu?.nombre }}</span> 
                                        </div>
                                    </div>
                                </div>
                            </button>
                        </b-col>
                        <b-col md="8" class="p-2" cols="3">
                            <div md-with-hover class="div-description">
                                <div>
                                    <div>
                                        <div class="md-title-description">
                                            <span>{{ subMenu?.descripcion }}</span> 
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </b-col>
                    </b-row>

                    <!-- Si no hay submenús, mostrar opciones por defecto -->
                    <template v-if="!visibleSubmenus.length && !isLoading">
                        <b-row id="home-buttons" v-for="item in defaultItems" :key="item.id">
                            <b-col md="4" class="p-2 admin-menu-card-col" cols="3">
                                <button
                                    type="button"
                                    class="md-card admin-menu-card-button"
                                    @click="goToRoute(item)"
                                >
                                    <div>
                                        <div>
                                            <div class="md-title-tarjeta">
                                                <span>{{ item.nombre }}</span> 
                                            </div>
                                        </div>
                                    </div>
                                </button>
                            </b-col>
                            <b-col md="8" class="p-2" cols="3">
                                <div md-with-hover class="div-description">
                                    <div>
                                        <div>
                                            <div class="md-title-description">
                                                <span>{{ item.descripcion }}</span> 
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </b-col>
                        </b-row>
                    </template>

                    <!-- Mensaje de carga -->
                    <div v-if="isLoading" class="text-center py-4">
                        <span>Cargando opciones...</span>
                    </div>
                </b-container>
            </div>
        </div>
    </div>
</template>

<script>
import SubMenu from '../../services/SubMenu'; 
import Menu from '../../services/Menu';

export default {
    name: "Consolidacion",
    data: () => ({
        listaSubMenu: [],
        isLoading: false,
        error: false,
        menuId: 5 // ID del menú de Consolidación
    }),
    computed: {
        labels() {
            if (this.$store.state._language == "es-ES") {
                return {
                    title: "Consolidación",
                    reclasifica: "RECLASIFICA",
                    reclasificad: "RECLASIFICACION DE SALDOS DE BALANCE",
                    noData: "No hay opciones disponibles",
                    error: "Error al cargar los datos",
                    balance: "BAL",
                    balanceDesc: "BALANCE GENERAL - COMPARATIVO - CONSOLIDADO",
                    esf: "ESF",
                    esfDesc: "SITUACION FINANCIERA - COMPARATIVO - CONSOLIDADO",
                    eri: "ERI",
                    eriDesc: "RESULTADO INTEGRAL",
                    efe: "EFE",
                    efeDesc: "FLUJO DE EFECTIVO",
                    ecp: "ECP",
                    ecpDesc: "CAMBIO EN EL PATRIMONIO",
                    eliminaciones: "ELIMINACIONES",
                    eliminacionesDesc: "ELIMINACION DE SALDOS",
                    topside: "TOPSIDE",
                    topsideDesc: "AJUSTES TOPSIDE"
                }
            } else {
                return {
                    title: "Consolidation",
                    reclasifica: "RECLASSIFY",
                    reclasificad: "RECLASSIFY ACCOUNTING STATEMENT",
                    noData: "No options available",
                    error: "Error loading data",
                    balance: "BAL",
                    balanceDesc: "GENERAL BALANCE - COMPARATIVE - CONSOLIDATED",
                    esf: "ESF",
                    esfDesc: "FINANCIAL SITUATION - COMPARATIVE - CONSOLIDATED",
                    eri: "ERI",
                    eriDesc: "COMPREHENSIVE INCOME",
                    efe: "EFE",
                    efeDesc: "CASH FLOW",
                    ecp: "ECP",
                    ecpDesc: "CHANGES IN EQUITY",
                    eliminaciones: "ELIMINACIONES",
                    eliminacionesDesc: "ELIMINATION OF BALANCES",
                    topside: "TOPSIDE",
                    topsideDesc: "TOPSIDE ADJUSTMENTS"
                }
            }
        },
        visibleSubmenus() {
            return this.listaSubMenu.length > 0 ? this.listaSubMenu : []
        },
        defaultItems() {
            // Opciones por defecto en caso de que no haya submenús
            return [
                {
                    id: "balance",
                    nombre: this.labels.balance,
                    descripcion: this.labels.balanceDesc,
                    ruta: "/balanceNiif"
                },
                {
                    id: "esf",
                    nombre: this.labels.esf,
                    descripcion: this.labels.esfDesc,
                    ruta: "/reporteEsf"
                },
                {
                    id: "eri",
                    nombre: this.labels.eri,
                    descripcion: this.labels.eriDesc,
                    ruta: "/reporteEri"
                },
                {
                    id: "efe",
                    nombre: this.labels.efe,
                    descripcion: this.labels.efeDesc,
                    ruta: "/reporteEfe"
                },
                {
                    id: "ecp",
                    nombre: this.labels.ecp,
                    descripcion: this.labels.ecpDesc,
                    ruta: "/reporteEcp"
                },
                {
                    id: "eliminaciones",
                    nombre: this.labels.eliminaciones,
                    descripcion: this.labels.eliminacionesDesc,
                    ruta: "/eliminaciones"
                },
                {
                    id: "topside",
                    nombre: this.labels.topside,
                    descripcion: this.labels.topsideDesc,
                    ruta: "/ajustesTopside"
                },
                {
                    id: "reclasifica",
                    nombre: this.labels.reclasifica,
                    descripcion: this.labels.reclasificad,
                    ruta: "/reclasificaBalance"
                }
            ]
        }
    },
    methods: {
        /**
         * Resuelve la ruta correcta a partir del objeto subMenu
         */
        resolveRoute(subMenu) {
            const rawPath = String(subMenu?.ruta || "").trim()
            const rawName = String(subMenu?.nombre || "").trim().toLowerCase()
            
            // Si tiene ruta definida, normalizarla
            if (rawPath) {
                // Normalizar la ruta (asegurar que empiece con /)
                let normalizedPath = rawPath.startsWith("/") ? rawPath : `/${rawPath}`
                // Eliminar espacios
                normalizedPath = normalizedPath.replace(/\s/g, '')
                
                // MAPEO CORRECTO DE RUTAS - Este es el punto clave
                const routeMapping = {
                    // ECP - Cambio en el Patrimonio
                    '/reporteecp': '/reporteEcp',
                    '/reporteECP': '/reporteEcp',
                    '/ecpreporte': '/reporteEcp',
                    '/ecpReporte': '/reporteEcp',
                    '/ecp': '/reporteEcp',
                    '/cambioenelpatrimonio': '/reporteEcp',
                    
                    // EFE - Flujo de Efectivo
                    '/reporteefe': '/reporteEfe',
                    '/reporteEFE': '/reporteEfe',
                    '/efereporte': '/reporteEfe',
                    '/efe': '/reporteEfe',
                    '/flujodeefectivo': '/reporteEfe',
                    
                    // ORI - Otros Resultados Integrales
                    '/reporteori': '/reporteOri',
                    '/reporteORI': '/reporteOri',
                    '/orireporte': '/reporteOri',
                    '/ori': '/reporteOri',
                    
                    // BALANCE
                    '/balance': '/balanceNiif',
                    '/balanceniif': '/balanceNiif',
                    
                    // ESF
                    '/esf': '/reporteEsf',
                    '/reporteesf': '/reporteEsf',
                    
                    // ERI
                    '/eri': '/reporteEri',
                    '/reporteeri': '/reporteEri',
                    
                    // ELIMINACIONES
                    '/eliminaciones': '/eliminaciones',
                    
                    // TOPSIDE
                    '/topside': '/ajustesTopside',
                    '/ajustestopside': '/ajustesTopside',
                    
                    // RECLASIFICA
                    '/reclasifica': '/reclasificaBalance',
                    '/reclasificabalance': '/reclasificaBalance'
                }
                
                // Verificar si la ruta normalizada está en el mapeo
                const normalizedLower = normalizedPath.toLowerCase()
                if (routeMapping[normalizedLower]) {
                    return routeMapping[normalizedLower]
                }
                
                // Verificar si la ruta ya existe en el router (case sensitive)
                const existingRoute = this.$router.getRoutes().find(route => 
                    route.path === normalizedPath
                )
                if (existingRoute) {
                    return normalizedPath
                }
                
                return normalizedPath
            }
            
            // Mapeo por nombre (fallback)
            const nameMapping = {
                // Español
                'balance general': '/balanceNiif',
                'balance': '/balanceNiif',
                'bal': '/balanceNiif',
                'situacion financiera': '/reporteEsf',
                'esf': '/reporteEsf',
                'resultado integral': '/reporteEri',
                'eri': '/reporteEri',
                'flujo de efectivo': '/reporteEfe',
                'efe': '/reporteEfe',
                'cambio en el patrimonio': '/reporteEcp',
                'ecp': '/reporteEcp',
                'eliminaciones': '/eliminaciones',
                'eliminacion de saldos': '/eliminaciones',
                'topside': '/ajustesTopside',
                'ajustes topside': '/ajustesTopside',
                'reclasifica': '/reclasificaBalance',
                'reclasificacion': '/reclasificaBalance',
                // Inglés
                'general balance': '/balanceNiif',
                'financial situation': '/reporteEsf',
                'comprehensive income': '/reporteEri',
                'cash flow': '/reporteEfe',
                'changes in equity': '/reporteEcp',
                'eliminations': '/eliminaciones',
                'balance elimination': '/eliminaciones',
                'topside adjustments': '/ajustesTopside',
                'reclassify': '/reclasificaBalance',
                'reclassification': '/reclasificaBalance'
            }
            
            // Buscar por nombre exacto
            if (nameMapping[rawName]) {
                return nameMapping[rawName]
            }
            
            // Buscar por coincidencia parcial en el nombre
            for (const [key, route] of Object.entries(nameMapping)) {
                if (rawName.includes(key) || key.includes(rawName)) {
                    return route
                }
            }
            
            console.warn(`No se pudo resolver la ruta para: ${rawName}`)
            return null
        },

        goToRoute(subMenu) {
            let targetRoute = null
            
            if (typeof subMenu === 'object' && subMenu !== null) {
                targetRoute = this.resolveRoute(subMenu)
            } else if (typeof subMenu === 'string') {
                targetRoute = subMenu
            }
            
            if (!targetRoute) {
                console.error('Ruta no válida:', subMenu)
                this.$toast?.error('La ruta no es válida')
                return
            }
            
            // Normalizar la ruta final
            let finalRoute = targetRoute.startsWith('/') ? targetRoute : `/${targetRoute}`
            // Eliminar espacios
            finalRoute = finalRoute.replace(/\s/g, '')
            
            console.log('Intentando navegar a:', finalRoute)
            
            // Obtener todas las rutas disponibles
            const allRoutes = this.$router.getRoutes()
            
            // 1. Intentar coincidencia exacta
            let routeExists = allRoutes.some(route => route.path === finalRoute)
            
            // 2. Si no existe, buscar por nombre (especialmente para rutas con parámetros)
            if (!routeExists) {
                // Buscar por nombre de ruta
                const routeByName = allRoutes.find(route => {
                    // Para ECP
                    if (finalRoute === '/reporteEcp' || finalRoute.includes('ecp') || finalRoute.includes('Ecp')) {
                        return route.name === 'reporteEcp' || route.name === 'ecpReporte'
                    }
                    // Para EFE
                    if (finalRoute === '/reporteEfe' || finalRoute.includes('efe') || finalRoute.includes('Efe')) {
                        return route.name === 'reporteEfe'
                    }
                    // Para ORI
                    if (finalRoute === '/reporteOri' || finalRoute.includes('ori') || finalRoute.includes('Ori')) {
                        return route.name === 'reporteOri' || route.name === 'oriReporte'
                    }
                    return route.path === finalRoute
                })
                
                if (routeByName) {
                    console.log('Encontrada ruta por nombre:', routeByName.path)
                    this.$router.push({ path: routeByName.path })
                    return
                }
            }
            
            // 3. Verificar nuevamente después de intentar buscar por nombre
            const routeExistsFinal = this.$router.getRoutes().some(route => route.path === finalRoute)
            
            if (!routeExistsFinal) {
                console.error(`La ruta ${finalRoute} no existe en el router`)
                console.log('Rutas disponibles:', allRoutes.map(r => r.path))
                this.$toast?.error(`La ruta ${finalRoute} no está disponible`)
                return
            }
            
            this.$router.push({ path: finalRoute })
        },

        async cargarDatos() {
            this.isLoading = true;
            this.error = false;
            
            try {
                // Intentar obtener el menú de consolidación
                const menusResponse = await Menu.getAllMenu()
                const menus = menusResponse?.data?.listMenu || []
                const consolidacionMenu = menus.find((menu) => {
                    const route = String(menu?.ruta || "").toLowerCase()
                    const name = String(menu?.nombre || "").toLowerCase()
                    return route === "consolidacion" || 
                           route === "/consolidacion" || 
                           name === "consolidacion" ||
                           name === "consolidation"
                })
                
                const menuId = consolidacionMenu?.id || this.menuId
                console.log('Menu ID usado:', menuId)
                
                const res = await SubMenu.subMenuByMenuByRol(menuId, this.$store.state.userRole)
                const submenus = res?.data?.submenus || []
                
                // Mapear y resolver rutas
                this.listaSubMenu = submenus.map(item => {
                    const resolvedRoute = this.resolveRoute(item)
                    return {
                        ...item,
                        nombre: item?.nombre || 'Sin nombre',
                        descripcion: item?.descripcion || 'Sin descripción',
                        ruta: resolvedRoute || item?.ruta || ''
                    }
                }).filter(item => item.ruta)
                
                console.log('Submenús cargados:', this.listaSubMenu)
                
            } catch (err) {
                console.error('Error al cargar datos:', err)
                this.error = true
                this.$toast?.error(this.labels.error)
            } finally {
                this.isLoading = false
            }
        }
    },
    mounted() {
        this.cargarDatos()
    }
}
</script>

<style src="../main.css"></style>

<style scoped>
.parametrizacion-scroll-shell,
.main-menu-scroll-shell {
    height: 650px;
}
</style>